import React, { useEffect, useState } from 'react';

import Spinner from './Spinner';

import tr from '../localization/translate';
import { load as loadMaps } from '../services/maps';

import './WaitForGoogleMaps.scss';

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export default function WaitForGoogleMaps(Component) {
  const WaitForGoogleMapsHOC = props => {
    const [isLoading, setIsLoading] = useState(!global.google?.maps);

    useEffect(() => {
      if (!global.google?.maps) {
        loadMaps();
        const callBack = () => setIsLoading(false);
        global.pendingGoogleMapsRequests?.push(callBack);

        return () => {
          if (callBack) {
            const index = global.pendingGoogleMapsRequests?.indexOf(callBack);

            if (index >= 0) {
              global.pendingGoogleMapsRequests.splice(index, 1);
            }
          }
        };
      }

      return () => {};
    }, []);

    if (isLoading) {
      return (
        <div styleName="container">
          <Spinner styleName="spinner" />
          <p className="text top_margin_16">{ tr('common.loading_google_maps') }</p>
        </div>
      );
    }

    return (<Component {...props} />);
  };

  WaitForGoogleMapsHOC.displayName = `WaitForGoogleMaps(${getDisplayName(Component)})`;

  return WaitForGoogleMapsHOC;
}
